module.exports = __webpack_public_path__ + "img/237.167c4e9b.jpg";